import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button } from "antd";

class ClientListPage extends Component {
  render() {
    const bread = [{ text: "Liste des clients" }];

    return (
      <Fragment>
        <Helmet>{title("Liste des clients")}</Helmet>

        <div className="client-list-page main-content">
          <Header title="Clients" bread={bread} />
          <List type="clients" />
        </div>
      </Fragment>
    );
  }
}

export default ClientListPage;
